<template>
  <div>
    <v-row no-gutters>
      <v-col sm="8" class="pa-0">
        <h2>Whitelist/Blacklist Items</h2>
      </v-col>
    </v-row>
    <v-row class="mx-auto" no-gutters>
      <v-col class="pa-0 mt-5">
        <WhiteList/>
        <BlackList/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import WhiteList from '@/components/SysSettings/EmailDomainList/WhiteList.vue';
import BlackList from '@/components/SysSettings/EmailDomainList/BlackList.vue';
export default {
  components: {
    WhiteList,
    BlackList
  },
  props: ['title']
};
</script>

<style>
.v-input--checkbox .v-input__control .v-messages {
  display: none;
}
.v-input--checkbox .v-input__control .v-input__slot {
  margin-bottom: 0;
}
</style>
